import type * as Types from '@precon-tools-suite-by-shared/precon-graphql-types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DownloadableFileFragment = {
  __typename: 'File',
  id: string,
  filename?: string | null,
  size?: string | null,
  url?: string | null
};

export type GetDownloadableFilesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type GetDownloadableFilesQuery = {
  __typename: 'Query',
  node?: {
    __typename: 'AddressFormat',
    id: string
  } | {
    __typename: 'AnalysisReport',
    id: string
  } | {
    __typename: 'AnalysisReportEntry',
    id: string
  } | {
    __typename: 'AnalysisReportEntryProbabilityOverwriteEvent',
    id: string
  } | {
    __typename: 'AnalysisReportEntrySeverityOverwriteEvent',
    id: string
  } | {
    __typename: 'AnalysisReportProductRisk',
    id: string
  } | {
    __typename: 'AssignProductCategoryToProductTodo',
    id: string
  } | {
    __typename: 'AssignSupplierBranchToProductTodo',
    id: string
  } | {
    __typename: 'Client',
    id: string
  } | {
    __typename: 'Comment',
    id: string
  } | {
    __typename: 'Company',
    id: string
  } | {
    __typename: 'Contact',
    id: string
  } | {
    __typename: 'Country',
    id: string
  } | {
    __typename: 'EchoFilesJob',
    id: string,
    files?: {
      __typename: 'FileConnection',
      edges?: Array<{
        __typename: 'FileEdge',
        cursor: string,
        node: {
          __typename: 'File',
          id: string,
          filename?: string | null,
          size?: string | null,
          url?: string | null
        }
      } | null> | null,
      pageInfo: {
        __typename: 'PageInfo',
        endCursor?: string | null,
        hasNextPage: boolean
      }
    } | null
  } | {
    __typename: 'ExportAnalysisReportEntriesJob',
    id: string,
    files?: {
      __typename: 'FileConnection',
      edges?: Array<{
        __typename: 'FileEdge',
        cursor: string,
        node: {
          __typename: 'File',
          id: string,
          filename?: string | null,
          size?: string | null,
          url?: string | null
        }
      } | null> | null,
      pageInfo: {
        __typename: 'PageInfo',
        endCursor?: string | null,
        hasNextPage: boolean
      }
    } | null
  } | {
    __typename: 'ExportProductsSpreadsheetJob',
    id: string,
    files?: {
      __typename: 'FileConnection',
      edges?: Array<{
        __typename: 'FileEdge',
        cursor: string,
        node: {
          __typename: 'File',
          id: string,
          filename?: string | null,
          size?: string | null,
          url?: string | null
        }
      } | null> | null,
      pageInfo: {
        __typename: 'PageInfo',
        endCursor?: string | null,
        hasNextPage: boolean
      }
    } | null
  } | {
    __typename: 'ExportSupplierBranchesSpreadsheetJob',
    id: string,
    files?: {
      __typename: 'FileConnection',
      edges?: Array<{
        __typename: 'FileEdge',
        cursor: string,
        node: {
          __typename: 'File',
          id: string,
          filename?: string | null,
          size?: string | null,
          url?: string | null
        }
      } | null> | null,
      pageInfo: {
        __typename: 'PageInfo',
        endCursor?: string | null,
        hasNextPage: boolean
      }
    } | null
  } | {
    __typename: 'ExportSupplierVCardsJob',
    id: string,
    files?: {
      __typename: 'FileConnection',
      edges?: Array<{
        __typename: 'FileEdge',
        cursor: string,
        node: {
          __typename: 'File',
          id: string,
          filename?: string | null,
          size?: string | null,
          url?: string | null
        }
      } | null> | null,
      pageInfo: {
        __typename: 'PageInfo',
        endCursor?: string | null,
        hasNextPage: boolean
      }
    } | null
  } | {
    __typename: 'ExportSuppliersSpreadsheetJob',
    id: string,
    files?: {
      __typename: 'FileConnection',
      edges?: Array<{
        __typename: 'FileEdge',
        cursor: string,
        node: {
          __typename: 'File',
          id: string,
          filename?: string | null,
          size?: string | null,
          url?: string | null
        }
      } | null> | null,
      pageInfo: {
        __typename: 'PageInfo',
        endCursor?: string | null,
        hasNextPage: boolean
      }
    } | null
  } | {
    __typename: 'File',
    id: string,
    filename?: string | null,
    size?: string | null,
    url?: string | null
  } | {
    __typename: 'GeneralAudit',
    id: string
  } | {
    __typename: 'Notification',
    id: string
  } | {
    __typename: 'PhoneNumberFormat',
    id: string
  } | {
    __typename: 'Product',
    id: string
  } | {
    __typename: 'ProductCategory',
    id: string
  } | {
    __typename: 'ProductCategoryAudit',
    id: string
  } | {
    __typename: 'ProductPredicateRequirement',
    id: string
  } | {
    __typename: 'ProvideRequiredProductPredicateValuesTodo',
    id: string
  } | {
    __typename: 'QuestionPredicate',
    id: string
  } | {
    __typename: 'Region',
    id: string
  } | {
    __typename: 'ResolveAnalysisReportProductRiskPredicateValueTodo',
    id: string
  } | {
    __typename: 'Risk',
    id: string
  } | {
    __typename: 'RiskAudit',
    id: string
  } | {
    __typename: 'RiskColumn',
    id: string
  } | {
    __typename: 'RiskConfiguration',
    id: string
  } | {
    __typename: 'RiskConfigurationLevel',
    id: string
  } | {
    __typename: 'RiskConfigurationProbability',
    id: string
  } | {
    __typename: 'RiskConfigurationSeverity',
    id: string
  } | {
    __typename: 'RiskProbabilityAudit',
    id: string
  } | {
    __typename: 'SelectAnalysisReportProductsTodo',
    id: string
  } | {
    __typename: 'SetRiskProbabilityValueForRiskConfigurationTodo',
    id: string
  } | {
    __typename: 'SetThreatSeverityValueForRiskConfigurationTodo',
    id: string
  } | {
    __typename: 'Supplier',
    id: string
  } | {
    __typename: 'SupplierBranch',
    id: string
  } | {
    __typename: 'SupplierReliability',
    id: string
  } | {
    __typename: 'Tag',
    id: string
  } | {
    __typename: 'Team',
    id: string
  } | {
    __typename: 'TeamLicense',
    id: string
  } | {
    __typename: 'TeamLicenseClass',
    id: string
  } | {
    __typename: 'Threat',
    id: string
  } | {
    __typename: 'ThreatAudit',
    id: string
  } | {
    __typename: 'ThreatCategory',
    id: string
  } | {
    __typename: 'ThreatCategoryAudit',
    id: string
  } | {
    __typename: 'ThreatSeverityAudit',
    id: string
  } | {
    __typename: 'User',
    id: string
  } | {
    __typename: 'UserInvitation',
    id: string
  } | {
    __typename: 'VerificationAction',
    id: string
  } | {
    __typename: 'VerificationConfiguration',
    id: string
  } | {
    __typename: 'VerificationConfigurationRule',
    id: string
  } | {
    __typename: 'VerificationPredicate',
    id: string
  } | null
};

export const DownloadableFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadableFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"download"},"value":{"kind":"BooleanValue","value":true}}]}]}}]} as unknown as DocumentNode<DownloadableFileFragment, unknown>;
export const GetDownloadableFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDownloadableFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadableFile"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HasFiles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadableFile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadableFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"download"},"value":{"kind":"BooleanValue","value":true}}]}]}}]} as unknown as DocumentNode<GetDownloadableFilesQuery, GetDownloadableFilesQueryVariables>;